import { useState } from 'react'
import { ShieldCheck } from './Icons'

type Props = {
  error: string
  busy: boolean
  onSubmit: (token: string) => Promise<void>
}

export function AdminLogin({ error, busy, onSubmit }: Props) {
  const [token, setToken] = useState('')

  return (
    <main className="login-screen">
      <section className="login-panel">
        <div className="login-brand">
          <span className="brand-mark">C</span>
          <strong>Curic Cloud</strong>
        </div>
        <div className="login-copy">
          <ShieldCheck size={25} />
          <h1>Admin access</h1>
          <p>Use the bootstrap token to create a short-lived signed admin session.</p>
        </div>
        <form
          onSubmit={(event) => {
            event.preventDefault()
            void onSubmit(token)
          }}
        >
          <label>
            Bootstrap token
            <input
              type="password"
              value={token}
              onChange={(event) => setToken(event.target.value)}
              autoComplete="current-password"
              required
              placeholder="Enter admin bootstrap token"
            />
          </label>
          {error && <p className="login-error">{error}</p>}
          <button className="primary-button" type="submit" disabled={busy}>
            {busy ? 'Signing in…' : 'Create admin session'}
          </button>
        </form>
      </section>
    </main>
  )
}
